import { UpdateMarketplaceV2, UpdateMarketplaceV2Variables } from './__generated__/UpdateMarketplaceV2'

import { gql } from 'apollo-boost'
import { useMutation } from '@apollo/react-hooks'

const MUTATION = gql`
  mutation UpdateMarketplaceV2($input: UpdateMarketplaceListingInputV2!) {
    updateMarketplaceListingV2(input: $input) {
      ... on MarketplaceListingErrorV2 {
        type
        error
      }
      ... on MarketplaceListingV2 {
        id
      }
    }
  }
`
export const useUpdateMarketplaceListingV2 = () =>
  useMutation<UpdateMarketplaceV2, UpdateMarketplaceV2Variables>(MUTATION)
